/**
 * Parses domain.json array into 4 domains for Observation Evaluation.
 * JSON structure: [_comment, domain1Title, domain1Questions, _comment, domain2Title, domain2Questions, ...]
 * Domain 3 (Instruction) and Domain 4 (Professional) are at indices 8 and 11 in the file.
 */
const DOMAIN_TITLES = {
  domain1: "Domain 1: Classroom Environment, Student Engagement and Commitment to Learning Teachers",
  domain2: "Domain 2: Planning for Active Learning",
  domain3: "Domain 3: Instruction for Active Learning",
  domain4: "Domain 4: Professional Responsibilities and Teacher Leadership",
};

const RATING_LABELS = ["Below Standard", "Developing", "Proficient", "Exemplary"];

export function parseDomainJson(arr) {
  if (!Array.isArray(arr) || arr.length < 12) return null;
  return [
    { title: DOMAIN_TITLES.domain1, questions: typeof arr[2] === "object" ? arr[2] : {} },
    { title: DOMAIN_TITLES.domain2, questions: typeof arr[5] === "object" ? arr[5] : {} },
    { title: DOMAIN_TITLES.domain3, questions: typeof arr[8] === "object" ? arr[8] : {} },
    { title: DOMAIN_TITLES.domain4, questions: typeof arr[11] === "object" ? arr[11] : {} },
  ];
}

export { RATING_LABELS };
